<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Resultado Vínculo Acompanhamento"
            description="Cidadãos e classificação por equipe no vínculo e acompanhamento."
            url="/vinculo-acompanhamento"
            :enabledModalInformacao="true"
            :enabledIframeModalInformacao="true"
            urlIframeModalInformacao="https://doc.clickup.com/9011510980/d/h/8cj1fp4-1631/599ea88448ce3d9/8cj1fp4-3491"
            pageIdentifier="diagnostico-situacional"
            :enableBadgeModalInformacao="
              Number(
                $store.state.permissoesRaw?.diagnostico_situacional_ajuda || 0
              ) > 0
            "
            :badgeValueModalInformacao="
              $store.state.permissoesRaw?.diagnostico_situacional_ajuda || 0
            "
            keyAjudaModalInformacao="diagnostico_situacional_ajuda"
          />
        </div>
      </div>
      <router-view></router-view>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'

export default {
  components: {
    Menu,
    Footer,
    SectionTitle,
  },
  metaInfo: {
    title: 'Vínculo e Acompanhamento - Resultado Municipal',
    titleTemplate: null,
  },
  data() {
    return {
      linksAjudaPec: [],
      linksAjudaCds: [],
    }
  },
}
</script>

<style></style>
